import { updateProspectCredentials } from './updateUserCredentials.thunks';
import { AuthState } from './authState';

export const reducers = {
  [updateProspectCredentials?.pending.type]: (state: AuthState): void => {
    state.updateProspectCredentials.showReCaptchaV2 = false;
  },
  [updateProspectCredentials?.fulfilled.type]: (state: AuthState): void => {
    state.updateProspectCredentials.showReCaptchaV2 = false;
  },
  [updateProspectCredentials?.rejected.type]: (state: AuthState): void => {
    state.updateProspectCredentials.showReCaptchaV2 = true;
  }
};
